import Btn from './Btn';
import Tx from './Tx';
import { useState } from 'react';
import FieldDialog from './dialogs/FieldDialog';
import { useEffect } from 'react';
import { api } from '../maps/data.js';
import InstallerFieldCard from './field/InstallerFieldCard';
import StoresColumn from './StoresColumn';

export default function StoresFields(props) {
    const [open_field_dialog, s_open_field_dialog] = useState(false);
    const [new_field, s_new_field] = useState(false);
    const [fields, s_fields] = useState([]);
    const [edit_item, s_edit_item] = useState({});

    const { selectedEdge, selectedSite, forceFieldUpdate } = props;


    const getFields = async () => {
        const res = await api({
            type: 'getFields',
            data: {
                edgeId: selectedEdge._id
            }
        });
        const data = res.map(item => {
            item.cameras = item.cameras?.map(camera => {
                const cameraItem = item.camerasList?.find(cam => cam._id === camera._id);
                return { ...camera, ...cameraItem, cameraId: camera._id };
            });
            return item;
        });
        s_fields(data);
    }

    useEffect(() => {
        getFields()
    }, [selectedEdge._id, forceFieldUpdate]);

    return (
        <StoresColumn color="#fdd54670">
            {fields.map(field => {
                return (<InstallerFieldCard
                    key={field._id}
                    {...field}
                    onEdit={() => {
                        s_new_field(false);
                        s_edit_item(field);
                        s_open_field_dialog(true);
                    }}
                    onDelete={async () => {
                        await api({ type: 'removeField', data: { fieldId: field._id } });
                        getFields();
                    }} />);
            })}
            <div><Btn startIcon="field" onClick={() => {
                s_new_field(true);
                s_edit_item({});
                s_open_field_dialog(true);
            }}><Tx>g.add</Tx></Btn></div>
            {
                open_field_dialog && (
                    <FieldDialog
                        siteId={selectedSite._id}
                        edgeId={selectedEdge._id}
                        open={open_field_dialog}
                        selectedSiteType={selectedSite.siteType}
                        newField={new_field}
                        field={edit_item}
                        edge={selectedEdge}
                        handleGetFields={() => {
                            getFields();
                        }}
                        onClose={() => {
                            s_open_field_dialog(false);
                            getFields();
                        }} />
                )
            }
        </StoresColumn>
    )
}
